import { useLocation } from "react-router-dom";
import EntertainmentRvcInput from "../../../../components/EntertainmentRvcInput";
import CustomHeaderTitle from "../../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../../components/HeaderBread";
import Layout from "../../../../Layout";

const MANAGEMENT_PATH = "/shore/back-office/entertainment/management";

const CreateEntertainmentRvc = () => {
  const location = useLocation();
  const defaultVesselId = (() => {
    const urlVesselId = new URLSearchParams(location.search).get("vesselId");
    return urlVesselId ? Number(urlVesselId) : "";
  })();

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Entertainment Management", route: MANAGEMENT_PATH },
    { title: "Add Revenue Center", route: `${MANAGEMENT_PATH}/add` },
  ];

  return (
    <Layout type={"create_per"} module_data={"Management"}>
      <CustomHeaderTitle title={"Create Revenue Center"} />
      <HeaderBread navigation={navigation} title={"Add Revenue Center"}></HeaderBread>
      <EntertainmentRvcInput rvc={{}} defaultVesselId={defaultVesselId} />
    </Layout>
  );
};

export default CreateEntertainmentRvc;
